import React, { useContext, useEffect, useState } from 'react'
import "../AdminDashboard.css"
import "./Return.css"
import axios from "axios"
import moment from "moment"
import { AuthContext } from '../../../../Context/AuthContext'
import { Card, Button, Badge, Select } from '../../../../ui'
import AssignmentReturnIcon from '@material-ui/icons/AssignmentReturn';
import BookIcon from '@material-ui/icons/Book';

function Return() {
    const API_URL = process.env.REACT_APP_API_URL
    const { user } = useContext(AuthContext)

    const [allTransactions, setAllTransactions] = useState([])
    const [ExecutionStatus, setExecutionStatus] = useState(null)
    const [allMembersOptions, setAllMembersOptions] = useState(null)
    const [borrowerId, setBorrowerId] = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    //Fetching all Members - load on focus
    const loadMembers = async () => {
        if (allMembersOptions && allMembersOptions.length > 0) return; // Already loaded
        try {
            const response = await axios.get(API_URL + "api/users/allmembers")
            if (response.data && response.data.length > 0) {
                setAllMembersOptions(response.data.map((member) => (
                    { value: `${member?._id}`, text: `${member?.userType === "Student" ? `${member?.userFullName}[${member?.admissionId}]` : `${member?.userFullName}[${member?.employeeId}]`}` }
                )))
            }
        }
        catch (err) {
            console.log("Error loading members:", err)
        }
    }

    /* Getting all active transactions */
    useEffect(() => {
        const getAllTransactions = async () => {
            try {
                const response = await axios.get(API_URL + "api/transactions/all-transactions")
                setAllTransactions(response.data.sort((a, b) => Date.parse(a.toDate) - Date.parse(b.toDate)).filter((data) => {
                    return data.transactionStatus === "Active"
                }))
                setExecutionStatus(null)
            }
            catch (err) {
                console.log(err)
            }
        }
        getAllTransactions()
    }, [API_URL, ExecutionStatus])

    const returnBook = async (transactionId, borrowerId, bookId, due) => {
        setIsLoading(true)
        try {
            await axios.put(API_URL + "api/transactions/update-transaction/" + transactionId, {
                isAdmin: user.isAdmin,
                transactionStatus: "Completed",
                returnDate: moment(new Date()).format("MM/DD/YYYY")
            })

            const borrowerdata = await axios.get(API_URL + "api/users/getuser/" + borrowerId)
            const points = borrowerdata.data.points

            if (due > 0) {
                await axios.put(API_URL + "api/users/updateuser/" + borrowerId, {
                    points: points - 10,
                    isAdmin: user.isAdmin
                })
            }
            else if (due <= 0) {
                await axios.put(API_URL + "api/users/updateuser/" + borrowerId, {
                    points: points + 10,
                    isAdmin: user.isAdmin
                })
            }

            const book_details = await axios.get(API_URL + "api/books/getbook/" + bookId)
            await axios.put(API_URL + "api/books/updatebook/" + bookId, {
                isAdmin: user.isAdmin,
                bookCountAvailable: book_details.data.bookCountAvailable + 1
            })

            await axios.put(API_URL + `api/users/${transactionId}/move-to-prevtransactions`, {
                userId: borrowerId,
                isAdmin: user.isAdmin
            })

            setExecutionStatus("Completed");
            alert("Book returned to the library successfully")
        }
        catch (err) {
            console.log(err)
            alert("Failed to return book. Please try again.")
        }
        setIsLoading(false)
    }

    const convertToIssue = async (transactionId) => {
        setIsLoading(true)
        try {
            await axios.put(API_URL + "api/transactions/update-transaction/" + transactionId, {
                transactionType: "Issued",
                isAdmin: user.isAdmin
            })
            setExecutionStatus("Completed");
            alert("Book issued successfully 🎆")
        }
        catch (err) {
            console.log(err)
            alert("Failed to convert reservation. Please try again.")
        }
        setIsLoading(false)
    }

    const issuedTransactions = allTransactions?.filter((data) => {
        if (borrowerId === null) {
            return data.transactionType === "Issued"
        }
        else {
            return data.borrowerId === borrowerId && data.transactionType === "Issued"
        }
    }) || []

    const reservedTransactions = allTransactions?.filter((data) => {
        if (borrowerId === null) {
            return data.transactionType === "Reserved"
        }
        else {
            return data.borrowerId === borrowerId && data.transactionType === "Reserved"
        }
    }) || []

    const calculateFine = (toDate) => {
        const daysOverdue = Math.floor((Date.parse(moment(new Date()).format("MM/DD/YYYY")) - Date.parse(toDate)) / 86400000)
        return daysOverdue <= 0 ? 0 : daysOverdue * 10
    }

    return (
        <div className="return-container">
            <h2 className="return-title">Return Books</h2>

            <Card padding="md" className="return-filter-card">
                <Select
                    id="member-filter-select"
                    label="Filter by Member"
                    placeholder="Select Member (Optional)"
                    searchable
                    clearable
                    value={borrowerId}
                    options={allMembersOptions || []}
                    onChange={(e) => setBorrowerId(e.target.value)}
                    onFocus={loadMembers}
                    onOpen={loadMembers}
                />
            </Card>

            {/* Issued Books Section */}
            <div className="return-section">
                <h3 className="return-section-title">Issued Books</h3>
                {issuedTransactions.length > 0 ? (
                    <Card padding="md" className="return-table-card">
                        <div className="return-table-wrapper">
                            <table className="return-table">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Book Name</th>
                                        <th>Borrower Name</th>
                                        <th>From Date</th>
                                        <th>To Date</th>
                                        <th>Fine</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {issuedTransactions.map((data, index) => {
                                        const fine = calculateFine(data.toDate)
                                        return (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{data.bookName}</td>
                                                <td>{data.borrowerName}</td>
                                                <td>{data.fromDate}</td>
                                                <td>{data.toDate}</td>
                                                <td>
                                                    <Badge variant={fine > 0 ? "danger" : "success"}>
                                                        ₹{fine}
                                                    </Badge>
                                                </td>
                                                <td>
                                                    <Button
                                                        variant="primary"
                                                        size="sm"
                                                        leadingIcon={<AssignmentReturnIcon />}
                                                        onClick={() => {
                                                            const daysOverdue = Math.floor((Date.parse(moment(new Date()).format("MM/DD/YYYY")) - Date.parse(data.toDate)) / 86400000)
                                                            return returnBook(data._id, data.borrowerId, data.bookId, daysOverdue)
                                                        }}
                                                        disabled={isLoading}
                                                    >
                                                        Return
                                                    </Button>
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </Card>
                ) : (
                    <Card padding="lg" className="return-empty-state">
                        <BookIcon style={{ fontSize: 48, marginBottom: 16 }} />
                        <p>No issued books found.</p>
                    </Card>
                )}
            </div>

            {/* Reserved Books Section */}
            <div className="return-section">
                <h3 className="return-section-title">Reserved Books</h3>
                {reservedTransactions.length > 0 ? (
                    <Card padding="md" className="return-table-card">
                        <div className="return-table-wrapper">
                            <table className="return-table">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Book Name</th>
                                        <th>Borrower Name</th>
                                        <th>From Date</th>
                                        <th>To Date</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {reservedTransactions.map((data, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{data.bookName}</td>
                                            <td>{data.borrowerName}</td>
                                            <td>{data.fromDate}</td>
                                            <td>{data.toDate}</td>
                                            <td>
                                                <Button
                                                    variant="primary"
                                                    size="sm"
                                                    leadingIcon={<BookIcon />}
                                                    onClick={() => convertToIssue(data._id)}
                                                    disabled={isLoading}
                                                >
                                                    Convert to Issue
                                                </Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </Card>
                ) : (
                    <Card padding="lg" className="return-empty-state">
                        <BookIcon style={{ fontSize: 48, marginBottom: 16 }} />
                        <p>No reserved books found.</p>
                    </Card>
                )}
            </div>
        </div >
    )
}

export default Return
